<template>
  <CardModule :class="isAdmin ? 'mt-6' : 'mt-0'" title="Tema">
    <h1 class="lojas-gerenciar-dados-cadastrais-subtitle">
      {{ $t("registrations.producers.color-definition") }}
    </h1>
    <v-divider></v-divider>
    <div class="search-form">
      <v-row class="mt-5">
        <v-col cols="6">
          <BaseTextField
            :label="$t('registrations.producers.primary-color')"
            required
            v-model="$loja_gerenciar.cadastro.tema.cor_primaria"
            v-mask="'!#XXXXXX'"
            height="51"
            class="textinput"
            :rules="[rules.required]"
          >
            <template v-slot:append>
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                offset-y
                transition="slide-y-transition"
              >
                <template v-slot:activator="{ on }">
                  <div :style="swatchStyle" v-on="on" />
                </template>
                <v-card>
                  <v-card-text>
                    <v-color-picker
                      v-model="$loja_gerenciar.cadastro.tema.cor_primaria"
                    />
                  </v-card-text>
                </v-card>
              </v-menu>
            </template>
          </BaseTextField>
        </v-col>
        <v-col cols="6">
          <BaseTextField
            :label="$t('registrations.producers.secondary-color')"
            required
            v-model="$loja_gerenciar.cadastro.tema.cor_secundaria"
            v-mask="'!#XXXXXX'"
            height="51"
            class="textinput"
            :rules="[rules.required]"
          >
            <template v-slot:append>
              <v-menu v-model="menu2" :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <div :style="swatchStyle2" v-on="on" />
                </template>
                <v-card>
                  <v-card-text>
                    <v-color-picker
                      v-model="$loja_gerenciar.cadastro.tema.cor_secundaria"
                    />
                  </v-card-text>
                </v-card>
              </v-menu>
            </template>
          </BaseTextField>
        </v-col>
      </v-row>
      <h1 class="lojas-gerenciar-dados-cadastrais-subtitle">
        {{ $t("registrations.producers.imply-advertising") }}
      </h1>
      <v-divider></v-divider>
      <v-row class="mt-5 pl-3 mb-3">
        <v-checkbox
          v-model="$loja_gerenciar.cadastro.tema.marketing_imply_ativo"
          :label="$t('registrations.producers.imply-advertising-banner')"
        >
        </v-checkbox>
      </v-row>
      <h1 class="lojas-gerenciar-dados-cadastrais-subtitle">
        {{ $t("registrations.producers.logo") }}
      </h1>
      <v-divider></v-divider>
      <v-row class="mt-5">
        <v-col
          cols="12"
          v-if="$loja_gerenciar.cadastro.tema.logotipo_ingresso.have"
        >
          <BaseTextField
            :label="$t('registrations.producers.ticket-logo')"
            show-size
            accept="image/png, image/jpeg, image/bmp"
            :placeholder="$t('registrations.producers.import-ticket-logo')"
            clearable
            :hint="$t('registrations.producers.ticket-logo-info')"
            persistent-hint
            v-model="$loja_gerenciar.cadastro.tema.logotipo_ingresso.imagem"
            prepend-icon=""
            append-icon="mdi-image-outline"
            clear-icon="mdi-close-circle-outline"
            :append-outer-icon="
              $loja_gerenciar.cadastro.tema.logotipo_ingresso.imagem
                ? 'mdi-eye-outline'
                : ''
            "
            :rules="rulesImg"
            @click:append-outer="
              previewImage(
                $loja_gerenciar.cadastro.tema.logotipo_ingresso.imagem
              )
            "
            @click:clear="removerImagem('logotipo_ingresso')"
            @change="
              getImagem(
                $loja_gerenciar.cadastro.tema.logotipo_ingresso.object,
                'logotipo_ingresso'
              )
            "
          ></BaseTextField>
        </v-col>
        <v-col cols="12" v-else>
          <v-file-input
            :label="$t('registrations.producers.ticket-logo')"
            show-size
            dense
            accept="image/png, image/jpeg, image/bmp"
            outlined
            :placeholder="$t('registrations.producers.import-ticket-logo')"
            clearable
            :hint="$t('registrations.producers.ticket-logo-info')"
            persistent-hint
            class="input-file-tema"
            v-model="$loja_gerenciar.cadastro.tema.logotipo_ingresso.object"
            prepend-icon=""
            append-icon="mdi-image-outline"
            clear-icon="mdi-close-circle-outline"
            :append-outer-icon="
              $loja_gerenciar.cadastro.tema.logotipo_ingresso.imagem
                ? 'mdi-eye-outline'
                : ''
            "
            :rules="rulesImg"
            @click:append-outer="
              previewImage(
                $loja_gerenciar.cadastro.tema.logotipo_ingresso.imagem
              )
            "
            @click:clear="removerImagem('logotipo_ingresso')"
            @change="
              getImagem(
                $loja_gerenciar.cadastro.tema.logotipo_ingresso.object,
                'logotipo_ingresso'
              )
            "
          ></v-file-input>
        </v-col>
        <v-col cols="12" v-if="$loja_gerenciar.cadastro.tema.logotipo_pos.have">
          <BaseTextField
            show-size
            accept="image/png, image/jpeg, image/bmp"
            :label="$t('registrations.producers.pos-logo')"
            :placeholder="$t('registrations.producers.import-pos-logo')"
            persistent-hint
            :error-messages="$loja_gerenciar.cadastro.tema.error.logotipo_pos"
            @input="$loja_gerenciar.cadastro.tema.error.logotipo_pos = []"
            clearable
            :hint="$t('registrations.producers.pos-logo-info')"
            v-model="$loja_gerenciar.cadastro.tema.logotipo_pos.imagem"
            prepend-icon=""
            clear-icon="mdi-close-circle-outline"
            append-icon="mdi-image-outline"
            :append-outer-icon="
              $loja_gerenciar.cadastro.tema.logotipo_pos.imagem
                ? 'mdi-eye-outline'
                : ''
            "
            :rules="rulesImg"
            @click:append-outer="
              previewImage($loja_gerenciar.cadastro.tema.logotipo_pos.imagem)
            "
            @click:clear="removerImagem('logotipo_pos')"
            @change="
              getImagem(
                $loja_gerenciar.cadastro.tema.logotipo_pos.object,
                'logotipo_pos'
              )
            "
          ></BaseTextField>
        </v-col>
        <v-col cols="12" v-else>
          <v-file-input
            show-size
            :label="$t('registrations.producers.pos-logo')"
            accept="image/png, image/jpeg, image/bmp"
            outlined
            dense
            :placeholder="$t('registrations.producers.import-pos-logo')"
            persistent-hint
            :error-messages="$loja_gerenciar.cadastro.tema.error.logotipo_pos"
            @input="$loja_gerenciar.cadastro.tema.error.logotipo_pos = []"
            :hint="$t('registrations.producers.pos-logo-info')"
            clearable
            class="input-file-tema"
            v-model="$loja_gerenciar.cadastro.tema.logotipo_pos.object"
            prepend-icon=""
            append-icon="mdi-image-outline"
            clear-icon="mdi-close-circle-outline"
            :append-outer-icon="
              $loja_gerenciar.cadastro.tema.logotipo_pos.imagem
                ? 'mdi-eye-outline'
                : ''
            "
            :rules="rulesImg"
            @click:append-outer="
              previewImage($loja_gerenciar.cadastro.tema.logotipo_pos.imagem)
            "
            @click:clear="removerImagem('logotipo_pos')"
            @change="
              getImagem(
                $loja_gerenciar.cadastro.tema.logotipo_pos.object,
                'logotipo_pos'
              )
            "
          ></v-file-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" v-if="$loja_gerenciar.cadastro.tema.logotipo.have">
          <BaseTextField
            :label="$t('registrations.producers.ecommerce-logo')"
            show-size
            accept="image/png, image/jpeg, image/bmp"
            :placeholder="$t('registrations.producers.import-logo')"
            :hint="$t('registrations.producers.ticket-logo-info')"
            persistent-hint
            clearable
            class="input-file-tema"
            v-model="$loja_gerenciar.cadastro.tema.logotipo.imagem"
            prepend-icon=""
            clear-icon="mdi-close-circle-outline"
            append-icon="mdi-image-outline"
            :error-messages="$loja_gerenciar.cadastro.tema.error.imagem_logo"
            @input="$loja_gerenciar.cadastro.tema.error.imagem_logo = []"
            :append-outer-icon="
              $loja_gerenciar.cadastro.tema.logotipo.imagem
                ? 'mdi-eye-outline'
                : ''
            "
            :rules="rulesImg"
            @click:append-outer="
              previewImage($loja_gerenciar.cadastro.tema.logotipo.imagem)
            "
            @click:clear="removerImagem('logotipo')"
            @change="
              getImagem(
                $loja_gerenciar.cadastro.tema.logotipo.object,
                'logotipo'
              )
            "
          ></BaseTextField>
        </v-col>
        <v-col
          cols="12"
          v-else-if="
            $loja_gerenciar.cadastro.configuracoes_rede.rede_compartilhada.includes(
              'ECOMMERCE'
            ) ||
            $loja_gerenciar.cadastro.configuracoes_rede.rede_privada.includes(
              'ECOMMERCE'
            )
          "
        >
          <v-file-input
            :label="$t('registrations.producers.ecommerce-logo')"
            show-size
            accept="image/png, image/jpeg, image/bmp"
            outlined
            dense
            :placeholder="$t('registrations.producers.import-logo')"
            :hint="$t('registrations.producers.ticket-logo-info')"
            persistent-hint
            clearable
            class="input-file-tema"
            :error-messages="$loja_gerenciar.cadastro.tema.error.imagem_logo"
            @input="$loja_gerenciar.cadastro.tema.error.imagem_logo = []"
            v-model="$loja_gerenciar.cadastro.tema.logotipo.object"
            prepend-icon=""
            clear-icon="mdi-close-circle-outline"
            append-icon="mdi-image-outline"
            :append-outer-icon="
              $loja_gerenciar.cadastro.tema.logotipo.imagem
                ? 'mdi-eye-outline'
                : ''
            "
            :rules="rulesImg"
            @click:append-outer="
              previewImage($loja_gerenciar.cadastro.tema.logotipo.imagem)
            "
            @click:clear="removerImagem('logotipo')"
            @change="
              getImagem(
                $loja_gerenciar.cadastro.tema.logotipo.object,
                'logotipo'
              )
            "
          ></v-file-input>
        </v-col>
      </v-row>
      <h1 class="lojas-gerenciar-dados-cadastrais-subtitle">
        {{ $t("registrations.producers.images-theme") }}
      </h1>
      <v-divider class="divider-title"></v-divider>
      <v-row class="mt-5">
        <v-col cols="12">
          <v-select
            outlined
            dense
            color="tertiary"
            class="rounded-lg"
            :label="$t('registrations.producers.type-of-image')"
            :items="filteredData"
            item-text="key"
            item-value="value"
            v-model="$loja_gerenciar.cadastro.tema.imagem"
            type="text"
            hide-details="auto"
            :no-data-text="$t('registrations.producers.all-images-included')"
            :error-messages="$loja_gerenciar.cadastro.tema.error.imagem"
            @input="$loja_gerenciar.cadastro.tema.error.imagem = []"
          >
            <template v-slot:item="{ item }">
              {{ translatedImageTypes(item.key, item.value) }}
            </template>
            <template v-slot:selection="{ item }">
              {{ translatedImageTypes(item.key, item.value) }}
            </template>
          </v-select>
        </v-col>
        <v-col cols="12">
          <v-file-input
            show-size
            accept="image/png, image/jpeg, image/bmp"
            outlined
            dense
            :placeholder="$t('registrations.producers.click-to-import-image')"
            :hint="$t('registrations.producers.images-theme-info')"
            persistent-hint
            clearable
            class="input-file-tema"
            v-model="$loja_gerenciar.cadastro.tema.imagem_upload.object"
            prepend-icon=""
            append-icon="mdi-image-outline"
            :clear-icon="$config.icons.clear"
            :append-outer-icon="
              $loja_gerenciar.cadastro.tema.imagem_upload.imagem
                ? 'mdi-eye-outline'
                : ''
            "
            :rules="rulesImg"
            @click:append-outer="
              previewImage($loja_gerenciar.cadastro.tema.imagem_upload.imagem)
            "
            @click:clear="clearImage()"
            @change="
              getImagem(
                $loja_gerenciar.cadastro.tema.imagem_upload.object,
                'banner'
              )
            "
          >
          </v-file-input>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex justify-end">
          <BaseButton
            :color="$config.dados.corinputs"
            :loading="$loja_gerenciar.cadastro.tema.loading_imagem"
            variant="filter"
            class="rounded-lg mt-2 mb-6"
            @click="
              uploadImage(
                $loja_gerenciar.cadastro.tema.imagem_upload.imagem,
                $loja_gerenciar.cadastro.tema.imagem_upload.object
              )
            "
          >
            {{ $t("registrations.producers.upload") }}
            <v-icon class="tema-icon ml-2">mdi-upload</v-icon>
          </BaseButton>
        </v-col>
      </v-row>
      <div
        class="imagens-table mb-4"
        v-if="
          $loja_gerenciar.cadastro.tema &&
          $loja_gerenciar.cadastro.tema.banners_array &&
          $loja_gerenciar.cadastro.tema.banners_array.length == 0
        "
      >
        <span>{{ $t("registrations.no-results-found") }}</span>
      </div>
      <v-simple-table fixed-header class="imagens-table mb-4" v-else>
        <template v-slot:default>
          <thead>
            <tr>
              <th
                v-for="(header, index) in headersImgs"
                :key="index"
                class="text-center table-header"
              >
                {{ header.title }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(bannerImg, index) in $loja_gerenciar.cadastro.tema
                .banners_array"
              :key="index"
            >
              <td class="text-center">{{ Object.keys(bannerImg)[0] }}</td>
              <td class="text-center">{{ Object.values(bannerImg)[0] }}</td>
              <td class="table-actions">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="$config.dados.corinputs"
                      height="30"
                      v-bind="attrs"
                      class="mr-2"
                      v-on="on"
                      width="30"
                      small
                      icon
                      dark
                      @click="previewImage(Object.values(bannerImg)[0])"
                    >
                      <v-icon>mdi-eye-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("registrations.producers.view") }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="$config.dados.corinputs"
                      height="30"
                      v-bind="attrs"
                      v-on="on"
                      width="30"
                      small
                      icon
                      dark
                      @click="
                        $loja_gerenciar.remover(
                          index,
                          'image',
                          Object.keys(bannerImg)[0],
                          $t(
                            'registrations.producers.delete-image-confirmation'
                          )
                        )
                      "
                    >
                      <v-icon> mdi-delete-outline </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("registrations.delete") }}</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <h1 class="lojas-gerenciar-dados-cadastrais-subtitle">
        {{ $t("registrations.producers.footer-banner-link") }}
      </h1>
      <v-divider class="divider-title"></v-divider>
      <v-row class="mt-5 mb-3">
        <v-col cols="12">
          <BaseTextField
            label="Link"
            :placeholder="
              $t('registrations.producers.insert-footer-banner-link')
            "
            v-model="$loja_gerenciar.cadastro.tema.banner_link"
            type="text"
            class="textinput"
          >
          </BaseTextField>
        </v-col>
      </v-row>
    </div>
  </CardModule>
</template>
<script>
import LojasGerenciarMixins from "@/mixins/Loja-Gerenciar.mixins.js";
import mixins from "@/mixins";

const { formRules } = mixins;
export default {
  name: "lojas-gerenciar-tema",
  mixins: [LojasGerenciarMixins, formRules],
  components: {
    CardModule: () => import("@/components/cards/CardModule.vue"),
    BaseTextField: () => import("@/components/forms/BaseTextField.vue"),
    BaseButton: () => import("@/components/forms/BaseButton.vue"),
  },
  data() {
    return {
      menu: false,
      menu2: false,
      customToolbar: [
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6],
          },
        ],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          {
            align: "",
          },
          {
            align: "center",
          },
          {
            align: "right",
          },
          {
            align: "justify",
          },
        ],
        // ["blockquote"],
        [
          {
            indent: "-1",
          },
          {
            indent: "+1",
          },
        ], // outdent/indent
        [
          {
            color: [],
          },
          {
            background: [],
          },
        ], // dropdown with defaults from theme
        ["clean"], // remove formatting button
      ],
    };
  },
  computed: {
    rulesImg() {
      return [
        v =>
          !v ||
          v.size < 2000000 ||
          typeof v === "string" ||
          this.$t("registrations.producers.image-size-error"),
      ];
    },
    swatchStyle() {
      const { menu } = this;
      return {
        backgroundColor: this.$loja_gerenciar.cadastro.tema.cor_primaria,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: menu ? "20px" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
    swatchStyle2() {
      const { menu2 } = this;
      return {
        backgroundColor: this.$loja_gerenciar.cadastro.tema.cor_secundaria,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: menu2 ? "20px" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
    filteredData() {
      return this.$loja_gerenciar.tipo_imagem.filter(
        item => item.show === true
      );
    },
  },
  methods: {
    translatedImageTypes(key, value) {
      switch (value) {
        case "banner_rodape":
          return this.$t("registrations.producers.footer-banner");
        default:
          return key;
      }
    },
  },
  watch: {
    "$loja_gerenciar.cadastro.tema.banners_array"(e) {
      e.forEach(obj => {
        const variacaoesFilter = this.$loja_gerenciar.tipo_imagem.find(
          o => Object.keys(obj)[0] === o.value
        );
        if (variacaoesFilter) {
          this.$loja_gerenciar.tipo_imagem.map((item, index) => {
            if (variacaoesFilter.value == item.value) {
              this.$loja_gerenciar.tipo_imagem[index].show = false;
            }
          });
        }
      });
    },
    "$loja_gerenciar.cadastro.tema.logotipo.imagem"(e) {
      if (e) {
        this.$loja_gerenciar.cadastro.tema.error.imagem_logo = [];
      }
    },
    "$loja_gerenciar.cadastro.tema.logotipo_pos"() {
      this.$loja_gerenciar.cadastro.tema.error.logotipo_pos = [];
    },
    "$loja_gerenciar.cadastro.tema.logotipo_ingresso"() {
      this.$loja_gerenciar.cadastro.tema.error.logotipo_ingresso = [];
    },
    "$loja_gerenciar.cadastro.tema.logotipo"() {
      this.$loja_gerenciar.cadastro.tema.error.logotipo = [];
    },
  },
  mounted() {
    this.$loja_gerenciar.tipo_imagem.forEach((obj, index) => {
      const variacaoesFilter =
        this.$loja_gerenciar.cadastro.tema.banners_array.find(
          o => Object.keys(o)[0] === obj.value
        );
      if (variacaoesFilter) {
        this.$loja_gerenciar.tipo_imagem[index].show = false;
      }
    });
  },
  destroyed() {
    this.$loja_gerenciar.cadastro.tema.cor_primaria = "#2D1A4C";
    this.$loja_gerenciar.cadastro.tema.cor_secundaria = "#2D1A4C";

    // logotipo
    this.$loja_gerenciar.cadastro.tema.logotipo.imagem = null;
    this.$loja_gerenciar.cadastro.tema.logotipo.have = false;
    delete this.$loja_gerenciar.cadastro.tema.logotipo.object;

    //logotipo_pos
    this.$loja_gerenciar.cadastro.tema.logotipo_pos.imagem = null;
    this.$loja_gerenciar.cadastro.tema.logotipo_pos.have = false;
    delete this.$loja_gerenciar.cadastro.tema.logotipo_pos.object;

    //logotipo_ingresso
    this.$loja_gerenciar.cadastro.tema.logotipo_ingresso.imagem = null;
    this.$loja_gerenciar.cadastro.tema.logotipo_ingresso.have = false;
    delete this.$loja_gerenciar.cadastro.tema.logotipo_ingresso.object;

    // banner1 desktop
    this.$loja_gerenciar.cadastro.tema.imagem_upload.imagem = null;
    delete this.$loja_gerenciar.cadastro.tema.imagem_upload.object;

    this.$loja_gerenciar.cadastro.tema.banners_array = [];
  },
};
</script>
<style scoped>
.lojas-gerenciar-dados-cadastrais-subtitle {
  width: 487px;
  font-size: 1em;
  align-self: flex-start;
  margin-top: 1.25rem;
}
.input-file-tema {
  border-radius: 0.625rem;
  width: 100%;
}
.imagens-table {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 1.25rem;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
}

.tema-icon {
  fill: var(--dl-color-gray-white) !important;
  width: 1.5rem;
  height: 1.5rem;
}
</style>
